module.exports = __webpack_public_path__ + "static/media/20240530075731_IMG_7386-min.47b22bf1.JPG";